import type { ProjectileHittable } from "../interfaces";
import { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { ZOrder } from "../zOrder";
import { Sound } from "./sounds/sound";
import { SoundId } from "./sounds/soundId";

export class MetalBlock extends PhysicalThing implements ProjectileHittable {
	static key = "MetalBlock";
	constructor(xy: XY) {
		super(xy, true);
	}

	getZOrder(): number {
		return ZOrder.SCENARIO;
	}

	onProjectileHit(_projectile: unknown): void {
		this.board!.addNonPhysicalThing(new Sound(SoundId.METAL_BANG, this.xy));
	}

	isHittable(): boolean {
		return true;
	}

	static deserialize(data: any): MetalBlock {
		const m = new MetalBlock(deserializeXY(data.xy));
		m.visualId = data.visualId;
		return m;
	}
}
